import axios from './http';
import { TarmedSectionDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/sections`;

export const getAllSections = (): Promise<Array<TarmedSectionDto>> => {
  return axios.get(apiUri)
      .then(result => result.data);
};
